import { injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';

@injectable()
export class CounterStore {
  count = 0;

  constructor() {
    makeAutoObservable(this);
  }

  increment() {
    this.count++;
  }

  decrement() {
    this.count--;
  }
}
